import React, { useState, useMemo } from 'react';
import { Popover, PopoverTrigger, PopoverContent } from '@shadcn/components/ui/popover';
import { Command, CommandInput, CommandList, CommandEmpty, CommandGroup, CommandItem } from '@shadcn/components/ui/command';
import { Button } from '@shadcn/components/ui/button';
import { Braces } from 'lucide-react';
import { groupFieldsByEntity } from './fieldUtils';

const TemplateVarButton = ({ fields = [], onInsert }) => {
  const [open, setOpen] = useState(false);

  const groupedFields = useMemo(() => groupFieldsByEntity(fields), [fields]);

  if (!fields.length) return null;

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          className="absolute top-1 right-1 h-6 w-6 p-0 text-gray-400 hover:text-gray-600"
          title="Insert template variable"
          type="button"
        >
          <Braces size={12} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-64 p-0" align="end">
        <Command>
          <CommandInput placeholder="Search fields..." className="h-9" />
          <CommandList>
            <CommandEmpty>No fields found.</CommandEmpty>
            {Object.entries(groupedFields).map(([group, groupFields]) => (
              <CommandGroup key={group} heading={group}>
                {groupFields.map((field) => (
                  <CommandItem
                    key={field.path}
                    value={`${field.label} ${field.path}`}
                    onSelect={() => {
                      onInsert(field.path);
                      setOpen(false);
                    }}
                    className="text-xs"
                  >
                    <span className="truncate">{field.label}</span>
                    <span className="ml-auto font-mono text-[10px] text-muted-foreground shrink-0">
                      {`{{${field.path}}}`}
                    </span>
                  </CommandItem>
                ))}
              </CommandGroup>
            ))}
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};

export default TemplateVarButton;
